import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";

const signup = async (name, email, password, role, phone, location, companyName, website, skills) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Auto-assign role based on email
    let assignedRole = 'freelancer'; // default

    // Check if email should have admin role
    // Admin emails: myselfabrar.23@gmail.com, ceo@nextgenaiinx.com, or any @nextgenaiinx.com
    if (
      email === 'myselfabrar.23@gmail.com' ||
      email === 'ceo@nextgenaiinx.com' ||
      email.endsWith('@nextgenaiinx.com')
    ) {
      assignedRole = 'admin';
    }

    // Create user document in Firestore
    await setDoc(doc(db, "users", user.uid), {
      name: name || "",
      email: email || "",
      role: assignedRole,
      phone: phone || "",
      location: location || "",
      companyName: companyName || "",
      website: website || "",
      skills: skills || [],
      createdAt: new Date().toISOString(),
      // Initialize stats
      totalProjects: 0,
      activeProjects: 0,
      completedProjects: 0,
      totalEarnings: 0,
      currentPayment: 0
    });

    return { user: { ...user, role: assignedRole }, token: await user.getIdToken() };
  } catch (error) {
    throw new Error(error.message);
  }
};

const login = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Fetch user details from Firestore
    const userDoc = await getDoc(doc(db, "users", user.uid));
    let userData = {};
    if (userDoc.exists()) {
      userData = userDoc.data();
    }

    return {
      user: { ...user, ...userData },
      token: await user.getIdToken()
    };
  } catch (error) {
    throw new Error(error.message);
  }
};

const logout = async () => {
  await signOut(auth);
  return { message: "Logged out successfully" };
};

const getMe = async () => {
  const user = auth.currentUser;
  if (!user) return null;

  const userDoc = await getDoc(doc(db, "users", user.uid));
  if (userDoc.exists()) {
    return { uid: user.uid, ...user, ...userDoc.data() };
  }
  return user;
}

const authService = {
  signup,
  login,
  logout,
  getMe,
};

export default authService;
